/**
 * アプリ全体で共有する表示名などの定数。
 *
 * アプリ名はヘッダー・ログイン画面・ブラウザタブ (index.html) の複数箇所に登場するため、
 * 文言のブレを防ぐ目的でここに集約する。
 * (index.html の `<title>` のみ静的 HTML 側にも同じ文言を記述している)
 */

/** 画面に表示するアプリ名 (何をするアプリか分かる名称にする) */
export const APP_TITLE = '車内放送コンテンツ管理システム (OBA-Core)';
